// TODO hook up network

const TransactionHistory = [
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
	{
		sender: {
			name: 'Brian Dawson',
			icon: 'url',
		},
		amount: '1000',
		date: 'July 25',
		memo: 'My Picture challenge',
	},
]

export default TransactionHistory



// WEBPACK FOOTER //
// ./src/query/transactions.js